"use strict";
exports.__esModule = true;
var regex = /^(?!(000|666|9))\d{3}-(?!00)\d{2}-(?!0000)\d{4}$/;
function default_1(s) {
    return regex.test(s.toLowerCase());
}
exports["default"] = default_1;
;
